import { SubmitButton } from "components/common/buttons/SubmitButton";
import ErrorMessage from "components/common/ErrorMessage";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { Modal, ModalBody, ModalFooter, ModalHeader, Toast } from "reactstrap";
import Api from "services/api";
import { useTranslation } from "react-i18next";

const CancelTranslationModal = ({ isOpen, onClose, onConfirm, transId }) => {
  const { t } = useTranslation();
  const methods = useForm();
  const {
    control,
    formState: { errors },
    handleSubmit,
    setValue,
  } = methods;

  useEffect(() => {
    methods.reset({ cancel_reason: "" });
  }, [isOpen, methods]);

  console.log(transId, "transId")

  const declineTranslation = async (data) => {
    const payload = new FormData();
    payload.append("reason", data.cancel_reason);
    console.log("DeclineTranslation called. transId:", transId);
    console.log("Payload cancel_reason:", data.cancel_reason);
    try {
      if (transId) {
        const response = await Api.declineTranslationById(transId, payload);
        console.log("Success:", response);
        // Toast(response?.data?.message);
         toast.success(response?.data?.message, {
            className: "successToast",
          });
        if (onConfirm) onConfirm(data, "cancel");
        onClose();
      } else {
        console.warn("transId is missing or invalid.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
      <form onSubmit={handleSubmit(declineTranslation)}>
        <ModalHeader className="header_modal align-items-center">
          <h5 className="modal-title_u">{t("translation.declineProject")}</h5>
        </ModalHeader>
        <ModalBody className="modal_form_body">
          <div className="step_cards min-height-auto">
            {/* Reason */}
            <div className="row-primary">
              <h2>{t("translation.reason")}</h2>
              <Controller
                name="cancel_reason"
                control={control}
                rules={{
                  required: t("translation.pleaseWriteReason"),
                }}
                render={({ field }) => (
                  <>
                    <textarea
                      className="type_inp input-in"
                      {...field}
                      placeholder={t("translation.reasonForCancel")}
                      required
                    ></textarea>

                    {errors?.cancel_reason?.message && (
                      <ErrorMessage text={errors?.cancel_reason?.message} />
                    )}
                  </>
                )}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <SubmitButton
            className={"tomatoRed"}
            btnText={t("translation.declineInvite")}
            type="submit"
          />
          <button className="Cancle_button" type="button" onClick={onClose}>
            {t("translation.close")}
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default CancelTranslationModal;
